module.exports = __webpack_public_path__ + "static/media/cotizadorPrestamos.c933c790.png";